import React from 'react';

import { Box, Skeleton } from '@mui/material';
import { BOOKING_CHANNELS_SKELETON } from 'views/V2/Integration/constants';

import styles from './channelListSkeleton.module.css';

const { ROW_COUNT, commonSkeletonProps } = BOOKING_CHANNELS_SKELETON;
const ROWS = Array.from({ length: ROW_COUNT }, (_, index) => index);

/**
 * Placeholder for the channel grid while the saved selection is being fetched.
 *
 * Shares its grid and row geometry with `ChannelList` so real rows land exactly
 * where the placeholders were and the list does not jump when data arrives. The
 * varied label widths come from CSS `nth-child` rules rather than inline styles.
 */
function ChannelListSkeleton() {
    return (
        <Box className={styles.grid}>
            {ROWS.map((row) => (
                <Box key={row} className={styles.row}>
                    <Skeleton {...commonSkeletonProps} className={styles.checkbox} />
                    <Skeleton {...commonSkeletonProps} className={styles.label} />
                </Box>
            ))}
        </Box>
    );
}

export default ChannelListSkeleton;
